/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'
import TimeAgo from './TimeAgo/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserSingleCircle from 'DesignSystem/Svgs/Tysiav2UserSingleCircle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Comment({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Comment"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let activityAuthorValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'author',
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let activityTextValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'text',
})
  return (<React.Fragment
>
<div
  data-testid="Comment.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Comment.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2UserSingleCircle
  viewPath={`${viewPath}/Tysiav2UserSingleCircle`}
 width={32}
 height={32}
/>
<div
  data-testid="Comment.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yk7NE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeM}
 lineHeight="100%"
 weight="medium"
 data="activity.author"
 text={activityAuthorValueData}
/>
<div
  data-testid="Comment.Horizontal:2"
  data-view-path={viewPath}
 style={{'--c-2-Z1Yk7NE': dtColorsNeutral900}}
 className={`views-block ${styles.Horizontal2}`}
>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 fontSize={dtTypographyFontsizeM}
 lineHeight="16px"
 data="activity.text"
 html={activityTextValueData}
/>
</div>
</div>
</div>
<TimeAgo
  viewPath={`${viewPath}/TimeAgo`}
/>
</div>
{children}
</React.Fragment>)
}